import PropTypes from 'prop-types'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import { useContext, useEffect, useRef } from 'react'
import { PluginContext, SET_SELECTED_PLUGIN_DATA } from '../context/context'
import { RightArrow } from '@styled-icons/boxicons-solid'
import LinkWithStatus from '../../../../common/LinkWithStatus'
import { FILE_CONFIG } from '../constants'
import { downloadFile } from '../../../../../utils/common'
import { getRequest } from '../../../../../services/base'
import { useParams } from 'react-router-dom'

const PluginFilesViewer = (props) => {
  let { vehicle } = useParams()
  const [state, dispatch] = useContext(PluginContext)
  const defId = useRef(null)
  const defObjInterval = useRef()

  useEffect(() => {
    if (state.selectedObject.id) {
      defId.current = state.selectedObject.id
      defObjInterval.current = setInterval(fetchSelectedDefInInterval, 5000)
    }
  }, [state.selectedObject.id])

  useEffect(() => {
    return () => clearInterval(defObjInterval.current)
  }, [])

  const fetchSelectedDefInInterval = async () => {
    if (defId.current) {
      let res = await getRequest(
        `/api/plugin/def/${defId.current}/?vehicle=${vehicle}`
      )
      dispatch({ type: SET_SELECTED_PLUGIN_DATA, data: res })
    }
  }

  return (
    <Modal
      onClose={() => {
        props.setShowModal(false)
      }}
      show={props.showModal}
    >
      <ModalHeader className={'text-white'}>
        <div>DEF File's Viewer</div>
        <div className="text-red-600 text-base">
          ** In case of files not generated then click on Generate File Button
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="flex flex-row flex-wrap items-center bg-tracer-lt-blue w-full py-2 px-3 border-b border-tracer-dark-blue text-white">
          <div className="w-6/12  pl-10">File Name</div>
          <div className="w-6/12  pl-10">Status</div>
        </div>
        {FILE_CONFIG.map((row, index) => {
          return (
            <div
              key={`file-config-${index}`}
              className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black"
            >
              <div className="w-6/12  pl-10">
                <RightArrow size="1.5rem" color="#0189E9" /> {row.name}
              </div>
              <div className="flex w-6/12  pl-10 flex-row flex-wrap items-center">
                {!state.selectedObject[row.key] ? (
                  state.selectedObject?.status == 1 ? (
                    <div className="">File Not Generated</div>
                  ) : (
                    <div className="">File Generation is in Progress ...</div>
                  )
                ) : (
                  <LinkWithStatus
                    href={`/administration/plant/new`}
                    className={
                      'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
                    }
                    title="Download"
                    onClickFunc={() => {
                      window.open(
                        `${state.selectedObject[row.key]}?timestamp=${Number(new Date())}`,
                        '_blank'
                      )
                    }}
                  />
                )}
              </div>
            </div>
          )
        })}

        <div className="flex justify-between mt-2">
          <div className="flex justify-between text-white">
            {state.selectedObject.def_file && (
              <LinkWithStatus
                href={``}
                className="underline py-1 px-2"
                title="Download DEF File"
                onClickFunc={() => {
                  downloadFile(
                    `${state.selectedObject.def_file}?timestamp=${Number(new Date())}`,
                    state.selectedObject.file_names['def_file']
                  )
                }}
              />
            )}

            {state.selectedObject.supp_file && (
              <LinkWithStatus
                href={``}
                className="underline py-1 px-2 ml-2"
                title="Download SUPP File"
                onClickFunc={() => {
                  downloadFile(
                    `${state.selectedObject.supp_file}?timestamp=${Number(new Date())}`,
                    state.selectedObject.file_names['supp_file']
                  )
                }}
              />
            )}
          </div>
          {state.selectedObject?.status != 2 && (
            <LinkWithStatus
              href={``}
              className="btn py-1 px-2"
              title="Generate Files"
              onClickFunc={() => {
                props.generateDefFiles(state.selectedObject.id)
                fetchSelectedDefInInterval()
              }}
            />
          )}
        </div>
      </ModalBody>
    </Modal>
  )
}

PluginFilesViewer.propTypes = {
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
}

export default PluginFilesViewer
